import api from '../../services/api';
import { Extra, Form, Payment } from '../payments/paymentsAPI';

export interface Cuota {
  anio: string;
  cuota: string;
  monto_interes: string;
  monto_multa: string;
  monto_origen: string;
  monto_total: string;
}

export interface Comprobante {
  tipo_comprob: string
  nro_comprob: string
  digito_ver: string
  tipo_imp: string
  nro_contrib: string
  nro_inmueble: string | null
  nro_comercio: string | null
  nro_rodado: string | null
  nro_cuenta: string | null
  estado: string
  monto_total: string
  monto_interes2?: string
  monto_interes3?: string
  fecha_vto: string
  fecha_vto2?: string
  fecha_vto3?: string
  monto_iva: string
  fecha_emision: string
  unif_recurso: string
  unif_anio: any
  unif_cuota: any
  oficio_nro: any
  oficio_ejercicio: any
  oficio_vto: any
  origen_emision: string
  audit_usuario_alta: string
  audit_fecha_alta: string
  audit_usuario_modi: string
  audit_fecha_modi: string
  fecha_decidir: string
  codbarra: string
  abonado: string
  cuotas: Cuota[]
}

export interface CuotaNotificacion {
  anio: string
  cuota: string
  orden_cc: string
  monto_total: string
  monto_origen: string
  monto_interes: string
  monto_interes_dto: string
  monto_multa: string
  monto_multa_dto: string
}

export interface ComprobanteNotificacion {
  tipo_comprob: string
  nro_comprob: string
  digito_ver: string
  tipo_imp: string
  nro_contrib: string
  nro_inmueble: string | null
  nro_comercio: string | null
  nro_rodado: string | null
  nro_cuenta: string | null
  estado: string
  monto_total: string
  monto_iva: string
  monto_interes2: string
  monto_interes3: string
  juicio: string
  id_in: string
  recurso: string
  remesa: string
  monto_dto: string
  audit_usuario_alta: string
  audit_fecha_alta: string
  audit_usuario_modi: string
  audit_fecha_modi: string
  cuotas: CuotaNotificacion[]
  fecha_vto: string
}

export interface CreateComprobantePayload {
  tipo: string;
  imponible: string;
  recurso: string;
  periods: string[];
  plan?: 1;
};


export interface PagarComprobantePayload {
  tipo: string;
  comprobante: string;
  gateway_id: string;
  email?: string;
  extra?: Extra;
}

export interface PagarComprobanteResponse {
  payment: Payment;
  url?: string;
  form?: Form;
}

export interface ObtenerComprobantePayload {
  tipo: number;
  numero: number;
}

async function create(payload: CreateComprobantePayload) {
  const response = await api<Comprobante>(
    'POST',
    `comprobantes`,
    payload
  );

  return response;
}


async function pay(payload: PagarComprobantePayload) {
  const response = await api<PagarComprobanteResponse>(
    'POST',
    `comprobantes/pagar`,
    payload
  );

  return response;
}

async function get(payload: ObtenerComprobantePayload) {
  const response = await api<Comprobante | ComprobanteNotificacion>(
    'GET',
    `comprobantes/${payload.tipo}-${payload.numero}`
  );

  return response;
}

const comprobantesAPI = {
  create,
  pay,
  get
};

export default comprobantesAPI;
